import { DragDropListItemProps } from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.interface';
import { DataFilterResultType } from '@pages-clean/admin/study/admin-data-views/filters/types';
import { ILocalState } from '@contexts/local-state-context';
import Constants, { RowDataSourceTableEnum } from '@utils/constants';

export const datasourceLOV = Constants.DataSourceLOV.filter(
    (x) =>
        x.value !== RowDataSourceTableEnum.Study &&
        x.value !== RowDataSourceTableEnum.Site &&
        x.value !== RowDataSourceTableEnum.Subject,
).sort((a, b) => a.key.localeCompare(b.key));

export const DataFilterSearch = (dataItem: DragDropListItemProps, search: string) => {
    return (
        dataItem.title === '' ||
        dataItem.title?.toString().toLocaleLowerCase().includes(search) ||
        dataItem.subtitle === '' ||
        dataItem.subtitle?.toString().toLocaleLowerCase().includes(search)
    );
};

export const mapDataFilterToDragDrop = (item: DataFilterResultType | undefined, state: ILocalState | null) => {
    const fieldDefinitionFields = state?.fields?.filter((field) => !field?.isHidden);
    return {
        id: item?.id as string,
        title: item?.label ?? '',
        subtitle: item?.fieldKey ?? '',
        active: fieldDefinitionFields?.filter((field) => item?.fieldKey?.includes(String(field?.key))).length !== 0,
        metadata: {
            recordId: item?.recordId as string,
            configId: item?.configId as string,
            createdDate: item?.created as Date,
            updatedDate: item?.updated as Date,
            createdBy: `${item?.createdBy?.firstName} ${item?.createdBy?.lastName}`,
            updatedBy: `${item?.updatedBy?.firstName} ${item?.updatedBy?.lastName}`,
        },
    };
};
